// extracted by extract-css-chunks-webpack-plugin
module.exports = {"login__cont":"_2u8axG","login__img":"G5qOYf","login__btn":"_2nNRyz"};